module.exports = __webpack_public_path__ + "img/snowflake-02.f7b5dfdd.png";